<template>
  <div id="useful-contacts-launcher-module" @click="consult()">
    <div class="launcher-module-header">
      <app-icon
        name="contact"
        size="tiny"/>
        <span>Contacts Utiles</span>
    </div>
    <template v-if="!entranceConfig.usefulNumbers.length">
      <div id="empty-template">
        - Aucun contact -
      </div>
    </template>
    <template v-else-if="contactOnDisplay !== null">
      <div id="contact-item">
        <span id="contact-title">{{ entranceConfig.usefulNumbers[contactOnDisplay].title }}</span>
        <span id="contact-content">{{ entranceConfig.usefulNumbers[contactOnDisplay].contact }}</span>
      </div>
    </template>
  </div>
</template>

<style lang="sass" scoped>
#useful-contacts-launcher-module
  .launcher-module-header
    border-top-color: #1565c0
    color: #1976d2
    svg
      color: #1976d2
#empty-template
  color: #9e9e9e
  display: flex
  justify-content: center
  font-family: 'RobotoLightItalic'
  font-size: .9em
  margin-top: 2rem
#contact-item
  display: flex
  flex-direction: column
  height: 100%
  margin-top: .5rem
  padding-left: 1.4rem
  span
    font-size: .9em
    line-height: 3.3rem
    overflow: hidden
    width: 95%
    white-space: nowrap
    &#contact-content
      background: -webkit-linear-gradient(45deg, #616161 75%, transparent)
      color: #616161
      font-family: 'RobotoBold'
      white-space: nowrap
      -webkit-background-clip: text
      -webkit-text-fill-color: transparent
    &#contact-title
      background: -webkit-linear-gradient(45deg, #616161 75%, transparent)
      color: #616161
      font-family: 'RobotoLightItalic'
      white-space: nowrap
      -webkit-background-clip: text
      -webkit-text-fill-color: transparent
</style>

<script>
import AppIcon from '@/components/icons/AppIcon.vue';

export default {
  name: 'UsefulContacts',

  components: {
    AppIcon,
  },

  props: {
    config: Object,
    entranceConfig: Object,
  },

  data() {
    return {
      contactOnDisplay: null,
      contactsSlideshow: null,
    };
  },

  mounted() {
    this.contactsDisplayManagement();
  },

  activated() {
    this.contactsDisplayManagement();
  },

  deactivated() {
    clearTimeout(this.contactsSlideshow);
    this.contactsSlideshow = null;
    this.contactOnDisplay = null;
  },

  methods: {
    contactsDisplayManagement() {
      clearTimeout(this.contactsSlideshow);
      this.contactsSlideshow = null;
      if (this.entranceConfig.usefulNumbers.length > 1) {
        this.contactOnDisplay = Math.floor(Math.random() * Math.floor(this.entranceConfig.usefulNumbers.length));
        this.contactsSlideshow = setTimeout(() => {
          this.contactsDisplayManagement();
        }, 3500);
      } else {
        this.contactOnDisplay = this.entranceConfig.usefulNumbers.length === 1 ? 0 : null;
      }
    },

    consult() {
      if (this.entranceConfig.usefulNumbers.length) {
        this.$router.push({ name: 'contactsPage' });
      }
    },
  },

  filters: {
    capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};
</script>
